/* eslint-disable */
import { Injectable, NgZone } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CONSTANTS } from './config.service';
import { ConnectivityService } from './connectivity.service';
import { GisService } from './gis.service';
import { LoggerService } from './logger.service';
import { PubSubService } from './pub-sub.service';
import { MSRemoteLoggerCategory } from 'src/app/adapters/remote-logger/utils/remote-logger.utils';

declare let Microsoft;

@Injectable({
  providedIn: 'root'
})
export class MapsTransitService {
  // THIS IS THE DEV KEY
  // apiKey: string = "AjmXEoj2kXbT1mNhn61mUN4tmxbOO0qPBVlUcgz7HvrJVmuUPb-yXsmDI5LYydD5";

  // THIS IS THE PRODUCTION KEY!!!!!!!!!!
  apiKey = 'AjNaemJoYOsLOPj2Ja2Y0_OVApNy77ImtERpJo9wy30cF8E3T5tJ05v35BuWqEtf';

  mapInitialised = false;
  placesInitialised = false;

  mapElement: any;

  map: any;
  points: any;
  pointsStartStop: any;
  center: any;
  bounds: any;

  markers: any = [];
  circles: any = [];
  infoWindows: any = [];
  paths: any = [];

  chosenTransitPointSubject: Subject<object> = new Subject<object>();
  chosenTransitPointNCESubject: Subject<object> = new Subject<object>();
  zoomInCloserSubject: Subject<object> = new Subject<object>();

  autoCompleteService: any;
  placesService: any;

  constructor(
    public connectivity: ConnectivityService,
    // private geolocation: Geolocation,
    private gis: GisService,
    public zone: NgZone,
    private logger: LoggerService,
    private pubSub: PubSubService
  ) {
    this.logger.log('Maps bing constructor', MSRemoteLoggerCategory.MAPS_TRANSIT_SERVICE);
  }

  //this is where we init the map
  init(mapElement: any, pointsStartStop: any, points: any, mapCenter: any): Promise<any> {
    this.mapElement = mapElement;
    this.points = points;
    this.pointsStartStop = pointsStartStop;
    this.center = mapCenter;
    this.markers = [];
    this.infoWindows = [];
    this.paths = [];

    return this.loadBingMaps();
  }

  /************************************************************************************************************************************************************************
   * Create map
   ************************************************************************************************************************************************************************/

  setBounds(): Promise<any> {
    // if (!this.points && !this.pointsStartStop) {
    if (!this.points) {
      this.logger.log('Getting current location from geolocation plugin.', MSRemoteLoggerCategory.MAPS_TRANSIT_SERVICE);
      this.center = this.getMicrosoftLocation(CONSTANTS.MAPS.DEFAULT_MAP_CENTER.lat, CONSTANTS.MAPS.DEFAULT_MAP_CENTER.lng);
      this.bounds = new Microsoft.Maps.LocationRect(this.center, 0, 0);
      return Promise.resolve(true);
    } else {
      const MicrosoftLocations = [];
      this.points.forEach((p) => {
        const location = this.getMicrosoftLocation(p.lat, p.lng);
        MicrosoftLocations.push(location);
      });
      this.pointsStartStop.forEach((p) => {
        const location = this.getMicrosoftLocation(p.lat, p.lng);
        MicrosoftLocations.push(location);
      });
      this.bounds = Microsoft.Maps.LocationRect.fromLocations(MicrosoftLocations);
      return Promise.resolve(false);
    }
  }

  initMap() {
    const self = this;
    this.mapInitialised = true;
    if (this.center && this.center instanceof Microsoft.Maps.Location == false) {
      this.logger.log(`Transitt found center`, MSRemoteLoggerCategory.MAPS_TRANSIT_SERVICE);
      this.center = this.getMicrosoftLocation(this.center.lat, this.center.lng);
    } else {
      this.logger.log(`Transit center is  ${JSON.stringify(this.center)}`, MSRemoteLoggerCategory.MAPS_TRANSIT_SERVICE);
    }

    return this.setBounds().then((res) => {
      const isDefaultCenter = res;
      const mapOptions = {
        credentials: this.apiKey,
        showZoomButtons: true,
        disableStreetside: true,
        disableStreetsideAutoCoverage: true,
        enableClickableLogo: false,
        enableInertia: true,
        showLocateMeButton: false,
        showMapTypeSelector: true,
        showScalebar: false,
        disableMapTypeSelectorMouseOver: true,
        navigationBarMode: Microsoft.Maps.NavigationBarMode['minified'],
        supportedMapTypes: ['aerial', 'road'],
        center: this.center,
        zoom: 16
      };
      this.logger.log('transittt am in here!!!!', MSRemoteLoggerCategory.MAPS_TRANSIT_SERVICE);

      this.map = new Microsoft.Maps.Map(this.mapElement, mapOptions);
      if (!this.center) {
        this.logger.log('transittt am in here with this center!!!!', MSRemoteLoggerCategory.MAPS_TRANSIT_SERVICE);
        this.map.setView({ bounds: this.bounds, padding: 50 });
      } else if (!isDefaultCenter) {
        this.logger.log('transittt am in here with default zoom', MSRemoteLoggerCategory.MAPS_TRANSIT_SERVICE);
        this.map.setView({ zoom: 16 });
      }

      //this.initPlaces();
    });
  }

  /************************************************************************************************************************************************************************
   * Reverse Geocode
   ************************************************************************************************************************************************************************/

  reverseGeocode(place) {
    return new Promise((resolve, reject) => {
      const searchRequest = {
        callback(r) {
          if (r && r.name.length > 0) {
            resolve(r);
          }
        },
        errorCallback(d) {
          reject(d);
        },
        includeEntityTypes: ['Address', 'Neighborhood'],
        includeNeighborhood: true,
        location: this.getMicrosoftLocation(place.lat, place.lng)
      };
      this.placesService.reverseGeocode(searchRequest);
    });
  }

  /************************************************************************************************************************************************************************
   * Place search
   ************************************************************************************************************************************************************************/

  selectPlace(place) {
    const location = {
      lat: null,
      lng: null,
      name: null
    };
    const self = this;
    const disallowedEntities = ['Postcode1', 'RoadBlock'];
    return new Promise((resolve, reject) => {
      const searchRequest = {
        where: place.entityType == 'LocalBusiness' ? place.structured_formatting.secondary_text : place.description,
        userData: {},
        callback(r, data) {
          self.zone.run(() => {
            self.logger.log(r, MSRemoteLoggerCategory.MAPS_TRANSIT_SERVICE);
            const validResults = r.results.filter((result) => disallowedEntities.indexOf(result.entityType) === -1);
            const hasAccurateResult = validResults.length > 0;
            const result = validResults.length > 0 ? validResults[0] : r.results[0];

            location.lat = result.location.latitude;
            location.lng = result.location.longitude;
            //we want to add the business title back onto the description we save/show if it's present
            location.name = data.title ? data.title + ', ' : '';
            location.name += result.name;
            resolve({ location, hasValidAccuracy: hasAccurateResult });
          });
        },
        errorCallback(d, e) {
          self.logger.log(d, MSRemoteLoggerCategory.MAPS_TRANSIT_SERVICE, e);
          // self.initPlaces();
          // self.placesService.geocode(d);
          reject(d);
        }
      };
      if (place.entityType == 'LocalBusiness') {
        searchRequest.userData = { title: place.structured_formatting.main_text };
      }
      this.placesService.geocode(searchRequest);
    });
  }

  searchPlace(query) {
    let places: any = [];

    return new Promise((resolve, reject) => {
      // if (query.length >= 3) {
      const config = { bounds: this.bounds, placeSuggestions: false, addressSuggestions: true };
      this.autoCompleteService.setOptions(config);
      this.autoCompleteService.getSuggestions(query, (predictions, status) => {
        places = [];
        //  let res = predictions.filter(function(result){ return result.entityId.includes('ypid')})
        predictions.forEach((prediction) => {
          const place = {
            description: prediction.formattedSuggestion,
            structured_formatting: {
              main_text: prediction.title,
              secondary_text: prediction.subtitle
            },
            entityType: prediction.entityType
          };

          places.push(place);
        });
        resolve(places);
      });
      // } else {
      //     resolve([]);
      // }
    });
  }

  loadPlacesService(element, center, points) {
    return Promise.resolve(true);
    //not gonna happen
  }

  initPlaces() {
    this.setBounds();
    this.placesInitialised = true;
    Microsoft.Maps.loadModule('Microsoft.Maps.AutoSuggest', () => {
      const options = {
        maxResults: 5,
        map: this.map,
        placeSuggestions: false,
        businessSuggestions: true,
        //useMapView:true,
        //userLocation: this.center,
        autoDetectLocation: false
      };

      this.autoCompleteService = new Microsoft.Maps.AutosuggestManager(options);
    });
    Microsoft.Maps.loadModule('Microsoft.Maps.Search', () => {
      this.placesService = new Microsoft.Maps.Search.SearchManager(this.map);
    });
  }

  /************************************************************************************************************************************************************************
   * Draw on map
   ************************************************************************************************************************************************************************/

  setPath(points, idx) {
    const MicrosoftLocations = [];
    points.forEach((p) => {
      const location = this.getMicrosoftLocation(p.lat, p.lng);
      MicrosoftLocations.push(location);
    });
    this.paths[idx].setLocations(MicrosoftLocations);
  }

  addPath(survey, points, opts?, page?) {
    // used for dashed or solid paths
    const defaultOpts = {
      // map: this.map,
      //geodesic: true,
      strokeColor: '#4DB8DB',
      strokeThickness: 8
    };

    // Define a symbol using SVG path notation, with an opacity of 1.
    const lineSymbol = {
      path: 'M 0,-1 0,1',
      strokeOpacity: 1,
      strokeWeight: 8,
      scale: 4
    };

    // Create the polyline, passing the symbol in the 'icons' property.
    // Give the line an opacity of 0.
    // Repeat the symbol at intervals of 20 pixels to create the dashed effect.
    const dashedOpts = {
      strokeOpacity: 1,
      strokeDashArray: [4, 4]
      /*icons: [{
                icon: lineSymbol,
                offset: '0',
                repeat: '26px'
            }]*/
    };
    const MicrosoftLocations = [];

    points.forEach((p) => {
      const location = this.getMicrosoftLocation(p.lat, p.lng);
      MicrosoftLocations.push(location);
    });

    if (page === 'split' || page === 'merge') {
      const mergedOpts = Object.assign({}, defaultOpts, opts);
      const path = new Microsoft.Maps.Polyline(MicrosoftLocations, mergedOpts);
      this.map.entities.push(path);
      this.paths.push(path);
    } else if (survey.rosterAdded) {
      const mergedOpts = Object.assign(defaultOpts, dashedOpts, opts);
      const path = new Microsoft.Maps.Polyline(MicrosoftLocations, mergedOpts);
      this.map.entities.push(path);
      this.paths.push(path);
    } else {
      //   let pickupPoints = [MicrosoftLocations[0], MicrosoftLocations[1]];
      //   let travelPoints = MicrosoftLocations.slice(1);
      //   let mergedOpts1 = Object.assign({}, defaultOpts, dashedOpts, { path: pickupPoints }, null);
      //   let mergedOpts2 = Object.assign({}, defaultOpts,             { path: travelPoints }, opts);
      //   let path1 = new Microsoft.Maps.Polyline(mergedOpts1);
      //   this.map.entities.push(path1);
      //   let path2 = new Microsoft.Maps.Polyline(mergedOpts2);
      //   this.map.entities.push(path2);
      //   this.paths = [path1, path2];
      const mergedOpts = Object.assign(defaultOpts, opts);
      const path = new Microsoft.Maps.Polyline(MicrosoftLocations, mergedOpts);
      this.map.entities.push(path);
      this.paths.push(path);
    }
  }

  addInfoWindow(opts) {
    let text = '';
    const infoboxOpts = { offset: new Microsoft.Maps.Point(0, 44), showCloseButton: false };
    const center = this.markers[opts.markerIdx].getLocation();
    let infobox: any;

    if (opts.content.title && opts.content.snippet) {
      text = '<strong>' + opts.content.title + '</strong><br/>' + opts.content.snippet;
    } else if (opts.content.title) {
      text = opts.content.title;
    } else if (opts.content.snippet) {
      text = opts.content.snippet;
    }

    infoboxOpts['description'] = text;

    infobox = new Microsoft.Maps.Infobox(center, infoboxOpts);
    infobox.setMap(this.map);
    this.infoWindows.push(infobox);
  }

  //for Bing Maps the info windows are separate entities and are not part of the map so we have to remove them this way
  closeInfoWindow(window) {
    window.setMap(null);
    this.infoWindows = [];
  }

  addMarker(opts) {
    const defaultAnchor = [15, 44]; // used for markers
    // we pass in a custom anchor for custom markers (like circle markers)
    const anchor = opts && opts.hasOwnProperty('icon') && opts.icon.hasOwnProperty('anchor') ? opts.icon.anchor : defaultAnchor;
    const defaultOpts = { anchor: new Microsoft.Maps.Point(anchor[0], anchor[1]) };
    const mergedOpts = Object.assign(defaultOpts, opts);
    const center = this.getMicrosoftLocation(opts.position.lat, opts.position.lng);
    let marker: any;

    mergedOpts.icon = opts.icon ? opts.icon.url : { url: './assets/imgs/marker-start-stop.png' };
    marker = new Microsoft.Maps.Pushpin(center, mergedOpts);
    this.map.entities.push(marker);
    this.markers.push(marker);
  }

  clear() {
    this.map.entities.clear();
    this.markers = [];
    this.circles = [];
    this.infoWindows = [];
    this.paths = [];
  }

  removeMarker(idx) {
    return Promise.resolve();
    // this.logger.log(this.map.layers);
    // this.logger.log(this.map.entities);

    // for (let i = this.map.entities.getLength() - 1; i >= 0; i--) {
    //     let entity = this.map.entities.get(i);
    //     if (entity instanceof Microsoft.Maps.Pushpin) {
    //         this.logger.log('Entity', entity)
    //         // this.map.entities.removeAt(i);
    //         // this.markers.pop();
    //         // break;
    //     }
    // }
  }

  // removeMarkers(count) {
  //     this.logger.log(this.map.layers);
  //     this.logger.log(this.map.entities);

  //     this.map.entities.clear();
  //     let removedCount = 0;

  //     for (let i = this.map.entities.getLength() - 1; i >= 0; i--) {
  //         let entity = this.map.entities.get(i);
  //         // this.logger.log('entity', entity.id, entity.entity);

  //         if (entity instanceof Microsoft.Maps.Pushpin) {
  //             this.map.entities.removeAt(i);
  //             this.markers.pop();
  //             removedCount++;
  //             if (removedCount === count) break;
  //         }
  //     }
  // }

  addCircle(opts) {
    const defaultOpts = {
      //map: this.map,
      strokeColor: '#FF0000',
      strokeThickness: 2,
      fillColor: '#FF0000'
      //radius: 8046
    };
    Microsoft.Maps.loadModule('Microsoft.Maps.SpatialMath', function () {
      const circle = this.createCircle(this.getMicrosoftLocation(opts.center.lat, opts.center.lng), 8046, defaultOpts);
      this.circles.push(circle);
      this.map.entities.push(circle);
    });
  }

  createCircle(center, radius, opts) {
    const locs = Microsoft.Maps.SpatialMath.getRegularPolygon(center, radius, 36, Microsoft.Maps.SpatialMath.DistanceUnits.Meters);
    return new Microsoft.Maps.Polygon(locs, opts);
  }

  /************************************************************************************************************************************************************************
   * Connectivity
   ************************************************************************************************************************************************************************/

  loadBingMaps(): Promise<any> {
    return new Promise(async (resolve) => {
      if (typeof Microsoft == 'undefined' || typeof Microsoft.Maps == 'undefined') {
        if (await this.connectivity.isOnline()) {
          window['mapInit'] = () => {
            //this.enableMap();
            this.initMap().then(() => {
              resolve(true);
            });
          };
          const script = document.createElement('script');
          script.id = 'bingMaps';
          script.type = 'text/javascript';
          script.async = true;
          script.defer = true;
          if (this.apiKey) {
            script.src = 'https://www.bing.com/api/maps/mapcontrol?callback=mapInit';
          } else {
            script.src = 'https://www.bing.com/api/maps/mapcontrol?callback=mapInit';
          }

          document.body.appendChild(script);
        }
      } else {
        if (await this.connectivity.isOnline()) {
          // this.enableMap();
          this.initMap().then(() => {
            resolve(true);
          });
        } else {
          //this.disableMap();
        }
      }

      this.addConnectivityListeners();
    });
  }

  addConnectivityListeners(): void {
    this.connectivity.networkStatus.subscribe((isConnected: boolean) => {
      if (isConnected) {
        setTimeout(() => {
          if (typeof Microsoft == 'undefined' || typeof Microsoft.Maps == 'undefined') {
            this.loadBingMaps();
          } else {
            if (!this.mapInitialised) {
              this.initMap().then(() => Promise.resolve(true));
            }
            this.enableMap();
          }
        }, 2000);
      } else {
        this.disableMap();
      }
    });
  }

  /************************************************************************************************************************************************************************
   * Trigger drawing on map
   ************************************************************************************************************************************************************************/

  addMarkersStartStopLd(points) {
    // consider adjusting position based on LD config
    const ptA = points[0];
    const ptB = points[points.length - 1];

    const latShift = environment.distanceConfig.latitudeShift;

    const a = {
      position: { lat: ptA.lat - 0.1, lng: ptA.lng },
      icon: { anchor: new Microsoft.Maps.Point(24, 0), url: './assets/imgs/marker-start-text.png' }
    };
    const b = {
      position: { lat: ptB.lat - latShift, lng: ptB.lng },
      icon: { anchor: new Microsoft.Maps.Point(24, 0), url: './assets/imgs/marker-stop-text.png' }
    };

    this.addMarker(a);
    this.addMarker(b);
  }

  addMarkersStartStop(points, survey) {
    const ptA = points[0];
    const ptB = points[points.length - 1];
    let a;
    let b;

    if (survey.addedTripType === 'LOOP') {
      a = { position: ptA, icon: { url: './assets/imgs/marker-start-stop.png' } };
      b = { position: ptB, icon: { url: './assets/imgs/marker-generic.svg' } };
      this.addLoopArrowOverlay(points);
    } else {
      a = { position: ptA, icon: { url: './assets/imgs/marker-start.svg' } };
      b = { position: ptB, icon: { url: './assets/imgs/marker-stop.svg' } };
    }

    this.addMarker(a);
    this.addMarker(b);
  }

  shiftMarkersStartStop(points) {
    // let zoomMap = {
    //     1 : 78271.52,
    //     2 : 39135.76,
    //     3 : 19567.88,
    //     4 : 9783.94,
    //     5 : 4891.97,
    //     6 : 2445.98,
    //     7 : 1222.99,
    //     8 : 611.50,
    //     9 : 305.75,
    //     10 : 152.87,
    //     11 : 76.44,
    //     12 : 38.22,
    //     13 : 19.11,
    //     14 : 9.55,
    //     15 : 4.78,
    //     16 : 2.39,
    //     17 : 1.19,
    //     18 : 0.60,
    //     19 : 0.30,
    // }

    if (!this.markers.length || this.markers.length < 2) {
      return;
    }
    const pt1 = points[0];
    const pt2 = points[points.length - 1];
    const p1 = new Microsoft.Maps.Location(pt1.lat, pt1.lng);
    const p2 = new Microsoft.Maps.Location(pt2.lat, pt2.lng);
    const p1Pixel = this.map.tryLocationToPixel(p1, Microsoft.Maps.PixelReference.control);
    const p2Pixel = this.map.tryLocationToPixel(p2, Microsoft.Maps.PixelReference.control);
    const pixelDiffX = p1Pixel.x - p2Pixel.x;

    if (Math.abs(pixelDiffX) < 20) {
      const shiftAmt = (20 - Math.abs(pixelDiffX)) / 2;
      const shiftDir = pixelDiffX < 0 ? -1 : 1;
      const p1PixelAdjusted = p1Pixel.x + shiftDir * shiftAmt;
      const p2PixelAdjusted = p2Pixel.x - shiftDir * shiftAmt;

      const p1Coords = this.map.tryPixelToLocation(
        new Microsoft.Maps.Point(p1PixelAdjusted, p1Pixel.y),
        Microsoft.Maps.PixelReference.control
      );
      const p2Coords = this.map.tryPixelToLocation(
        new Microsoft.Maps.Point(p2PixelAdjusted, p2Pixel.y),
        Microsoft.Maps.PixelReference.control
      );

      this.markers[0].setLocation(p1Coords);
      this.markers[1].setLocation(p2Coords);
    } else {
      this.markers[0].setLocation(p1);
      this.markers[1].setLocation(p2);
    }
    // if (pixelDiffX < 80) {

    //     let p1PixelAdjusted = p1Pixel.x + 40 + (pixelDiffX / 2) * pixelsPerMeter;
    //     let p2PixelAdjusted = p2Pixel.x - 40 + (pixelDiffX / 2) * pixelsPerMeter;

    //     let p1Coords = this.map.tryPixelToLocation(new Microsoft.Maps.Point(p1PixelAdjusted, p1Pixel.y), Microsoft.Maps.PixelReference.control);
    //     let p2Coords = this.map.tryPixelToLocation(new Microsoft.Maps.Point(p2PixelAdjusted, p2Pixel.y), Microsoft.Maps.PixelReference.control);

    //     this.markers[0].setLocation(p1Coords);
    //     this.markers[1].setLocation(p2Coords);
    // }

    // let myMeters = 200;
    // let zoom = this.map.getZoom();
    // let metersPerPixel = 611.5;
    // let pixelsPerMarker = 40;
    // let m1 = this.markers[0];
    // let m2 = this.markers[1];
    // let x = pixelsPerMarker / metersPerPixel / myMeters;

    // if (myMeters < metersPerPixel) {
    //     // m1.setLocation(new Microsoft.Maps.Location(ptA.lat + 1, ptA.lng + 1));
    //     // m2.setLocation(new Microsoft.Maps.Location(ptB.lat - 1, ptB.lng - 1));
    // }

    // loc = this.map.getCenter();
    // point = map.tryLocationToPixel(loc, Microsoft.Maps.PixelReference.control);

    // this.addMarker(a);
    // this.addMarker(b);
  }

  getStraightLineDistance(oLat, oLng, dLat, dLng) {
    return Math.sqrt(Math.pow(dLat - oLat, 2) + Math.pow(dLng - oLng, 2));
  }

  getBearing(p1, p2) {
    let x;
    let y;
    let brng;
    const BRNG_ADJUST_FACTOR = 100;
    const lat1 = p1.lat;
    const lon1 = p1.lng;
    const lat2 = p2.lat;
    const lon2 = p2.lng;

    y = Math.sin(lon2 - lon1) * Math.cos(lat2);
    x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1);
    brng = Math.atan2(y, x) * (180.0 / Math.PI);

    if (brng < 0) {
      brng = 360 + brng;
    }

    return brng - BRNG_ADJUST_FACTOR;
  }

  addLoopArrowOverlay(points) {
    const overlayBounds = this.getLoopOverlayBounds(points[0], points[1]);
    const overlayBearing = this.getBearing(points[0], points[1]);
    const MicrosoftLocations = [];
    overlayBounds.forEach((p) => {
      const location = this.getMicrosoftLocation(p.lat, p.lng);
      MicrosoftLocations.push(location);
    });
    const bounds = Microsoft.Maps.LocationRect.fromLocations(MicrosoftLocations);
    const overlay = new Microsoft.Maps.GroundOverlay({
      bounds,
      imageUrl: 'assets/imgs/circular_arrows.png',
      opacity: 1,
      beneathLabels: true,
      rotation: overlayBearing
    });
    this.map.layers.insert(overlay);
  }

  getLoopOverlayBounds(p1, p2) {
    const center = { lat: null, lng: null };
    let dist;
    const bounds = [];
    const DIST_FACTOR = 1.6;

    center.lat = (p1.lat + p2.lat) / 2;
    center.lng = (p1.lng + p2.lng) / 2;
    dist = this.getStraightLineDistance(center.lat, center.lng, p2.lat, p2.lng) * DIST_FACTOR;

    bounds[0] = { lat: center.lat + dist, lng: center.lng + dist };
    bounds[1] = { lat: center.lat - dist, lng: center.lng - dist };

    return bounds;
  }
  // used in LD. consider adjusting radii based on LD config
  addCirclesStartStop(points, survey) {
    // start radius always 1 mile
    // debug dwell = 10 meters -> zoom: 9, o
    // short dwell = 1 mile
    // st    dwell = 25 miles
    const a = { center: points[0] };
    // let b = { center: points[points.length - 1], radius: CONSTANTS.tripRecording.DWELL_METERS };
    const b = { center: points[points.length - 1], radius: CONSTANTS.tripRecording.DWELL_METERS };

    this.addCircle(a);
    this.addCircle(b);
  }

  addMarkersAndPath(points, survey) {
    this.addMarkersStartStop(points, survey);

    if (survey.addedTripType === 'LOOP') {
      // TODO - add markers
    } else {
      this.addPath(survey, points);
    }
  }

  addCirclesAndMarkers(points, survey) {
    this.addCirclesStartStop(points, survey);
    this.addMarkersStartStopLd(points);
  }

  /************************************************************************************************************************************************************************
   * Map tabs
   ************************************************************************************************************************************************************************/

  showOverview(opts?) {
    this.map.setView({ bounds: this.bounds, padding: 50 });
  }

  showPoint(point, opts?) {
    const defaultOpts = {
      zoom: 18
    };

    const mergedOpts = Object.assign(defaultOpts, opts);

    this.map.setView({ center: this.getMicrosoftLocation(point.lat, point.lng), zoom: mergedOpts.zoom });
  }

  /************************************************************************************************************************************************************************
   * Update map
   ************************************************************************************************************************************************************************/

  setMapCenter(loc) {
    this.map.setView({ center: this.getMicrosoftLocation(loc.lat, loc.lng) });
    return Promise.resolve();
  }

  setMapTypeId(maptype) {
    this.map.setMapType(Microsoft.Maps.MapTypeId[maptype]);
  }

  setMapZoom(zoom) {
    return this.map.setView({ zoom });
  }

  resizeMap() {
    //TODO NOT SURE IF THERE IS AN EQUIVALENT MICROSOFT
    //google.maps.event.trigger(this.map, "resize");
  }

  setMapBounds(points) {
    const MicrosoftLocations = [];

    points.forEach((p) => {
      const location = this.getMicrosoftLocation(p.lat, p.lng);
      MicrosoftLocations.push(location);
    });

    this.bounds = Microsoft.Maps.LocationRect.fromLocations(MicrosoftLocations);
    this.map.setView({ bounds: this.bounds, padding: 10 });
  }

  /************************************************************************************************************************************************************************
   * Helpers
   ************************************************************************************************************************************************************************/

  getMicrosoftLocation(lat, lng) {
    return new Microsoft.Maps.Location(lat, lng);
  }

  getMicrosoftLocationRect() {
    return new Microsoft.Map.LocationRect();
  }

  setVisible(object, value) {
    object.setOptions({ visible: value });
  }

  setMarkerPosition(marker, position) {
    marker.setLocation(new Microsoft.Maps.Location(position.lat, position.lng));
    this.map.entities.add(marker);
  }

  disableMap(): void {
    // if(this.pleaseConnect) { this.pleaseConnect.style.display = "block" }
  }

  enableMap(): void {
    // if(this.pleaseConnect) { this.pleaseConnect.style.display = "none" }
  }

  getMapCenter() {
    const center = this.map.getCenter();
    return { lat: center.latitude, lng: center.longitude };
  }

  addViewChangeEndEvent() {
    const self = this;
    Microsoft.Maps.Events.addHandler(this.map, 'viewchangeend', () => {
      self.pubSub.publish(CONSTANTS.EVENTS.mapViewChanged);
    });
  }

  /***********************************************************************************************************************************************************************
   * Transit
   ************************************************************************************************************************************************************************/

  showTransitOverview(opts?) {
    this.map.setView({ bounds: this.bounds, padding: 0 });
  }

  addMarkersAndPathTransit(points) {
    // this.addMarkersTransitWithClusters(points);
    this.addMarkersTransit(points);
    this.addPathTransit(points);
  }

  addMarkersTransit(points) {
    for (const [i, point] of points.entries()) {
      const center = new Microsoft.Maps.Location(point.lat, point.lng);
      // var pin = new Microsoft.Maps.Pushpin(center, { title: point.text, text: (i + 1).toString() });
      const pin = new Microsoft.Maps.Pushpin(center, { title: point.text });

      Microsoft.Maps.Events.addHandler(pin, 'click', () => {
        const zoom = this.map.getZoom();
        const allowSelection = this.allowSelection(point, zoom);
        if (allowSelection) {
          this.chosenTransitPointSubject.next(point);
        } else {
          this.map.setView({ center: this.getMicrosoftLocation(point.lat, point.lng), zoom: zoom + 3 });
          this.chosenTransitPointNCESubject.next(point);
        }
      });

      this.map.entities.push(pin);
    }

    Microsoft.Maps.Events.addHandler(this.map, 'click', () => {
      this.zoomInCloserSubject.next(null);
    });
  }

  addMarkersTransitWithClusters(points) {
    const transitpins = [];
    for (const [i, point] of points.entries()) {
      const center = new Microsoft.Maps.Location(point.lat, point.lng);
      const pin = new Microsoft.Maps.Pushpin(center, { title: point.text });

      Microsoft.Maps.Events.addHandler(pin, 'click', () => {
        const zoom = this.map.getZoom();
        this.logger.log(`Transittt zoom is ${zoom}`, MSRemoteLoggerCategory.MAPS_TRANSIT_SERVICE);
        const allowSelection = this.allowSelection(point, zoom);
        if (allowSelection) {
          this.chosenTransitPointSubject.next(point);
        } else {
          this.map.setView({ center: this.getMicrosoftLocation(point.lat, point.lng), zoom: zoom + 3 });
          this.chosenTransitPointNCESubject.next(point);
        }
      });

      transitpins.push(pin);
    }

    Microsoft.Maps.loadModule('Microsoft.Maps.Clustering', () => {
      const clusterLayer = new Microsoft.Maps.ClusterLayer(transitpins, { gridSize: 25 });
      this.map.layers.insert(clusterLayer);
    });
  }

  // Determine if we allow the user to select the point that is tapped
  // Allow selection based on zoom level and proximity to closest neighbor
  allowSelection(point: any, zoom: number) {
    if (zoom < 7) {
      return false;
    }
    if (zoom > 18) {
      return true;
    }

    let allowSelect = false;
    const minDistance = this.getMinDistance(point);
    this.logger.log(`Transittt min distance is ${minDistance}`, MSRemoteLoggerCategory.MAPS_TRANSIT_SERVICE);

    switch (zoom) {
      case 7:
        if (minDistance >= 7000) {
          allowSelect = true;
        }
        break;
      case 8:
        if (minDistance >= 5000) {
          allowSelect = true;
        }
        break;
      case 9:
        if (minDistance >= 909) {
          allowSelect = true;
        }
        break;
      case 10:
        if (minDistance >= 721) {
          allowSelect = true;
        }
        break;
      case 11:
        if (minDistance >= 349) {
          allowSelect = true;
        }
        break;
      case 12:
        if (minDistance >= 286) {
          allowSelect = true;
        }
        break;
      case 13:
        if (minDistance >= 60) {
          allowSelect = true;
        }
        break;
      case 14:
        if (minDistance >= 25) {
          allowSelect = true;
        }
        break;
      case 15:
        if (minDistance >= 12) {
          allowSelect = true;
        }
        break;
      case 16:
        if (minDistance >= 6.49) {
          allowSelect = true;
        }
        break;
      case 17:
        if (minDistance >= 3.22) {
          allowSelect = true;
        }
        break;
      case 18:
        if (minDistance >= 2.17) {
          allowSelect = true;
        }
        break;
      default:
        this.logger.log(`Transittt got in default `, MSRemoteLoggerCategory.MAPS_TRANSIT_SERVICE);
    }

    return allowSelect;
  }

  getMinDistance(point: any) {
    let minDis = 100000.0;
    // Get the distance between this point and its closest neighbor
    for (const p of this.points) {
      if (p.lat === point.lat && p.lng === point.lng && p.title === point.title) {
        continue;
      }
      const distance = Math.abs((point.lat - p.lat) * 10000) + Math.abs((point.lng - p.lng) * 10000);
      if (distance < minDis) {
        minDis = distance;
      }
    }
    return minDis;
  }

  addPathTransit(points) {
    // used for dashed or solid paths
    const defaultOpts = {
      // map: this.map,
      //geodesic: true,
      strokeColor: '#4DB8DB',
      // strokeColor: '#d44dB9',
      // strokeColor: '#EDE4E3',
      strokeThickness: 8
    };

    // Define a symbol using SVG path notation, with an opacity of 1.
    const lineSymbol = {
      path: 'M 0,-1 0,1',
      strokeOpacity: 1,
      strokeWeight: 8,
      scale: 4
    };

    // Create the polyline, passing the symbol in the 'icons' property.
    // Give the line an opacity of 0.
    // Repeat the symbol at intervals of 20 pixels to create the dashed effect.
    const dashedOpts = {
      strokeOpacity: 1,
      strokeDashArray: [4, 4]
      /*icons: [{
                icon: lineSymbol,
                offset: '0',
                repeat: '26px'
            }]*/
    };
    const MicrosoftLocations = [];

    points.forEach((p) => {
      const location = this.getMicrosoftLocation(p.lat, p.lng);
      MicrosoftLocations.push(location);
    });

    const path = new Microsoft.Maps.Polyline(MicrosoftLocations, defaultOpts);
    this.map.entities.push(path);
    this.paths.push(path);
  }
}
